/* eslint-disable jira/filename-case */
import { useTenantContext } from '../tenant-context/index.tsx';

type ActivationId = string;

/**
 * Returns the activation ID for the current tenant.
 *
 * @agent-skills: tenant-context
 */
export const useActivationId = (): ActivationId => {
	const tenantContext = useTenantContext();
	return tenantContext && tenantContext.activationId;
};
